import { createFileRoute, notFound } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { getDrawingByShareId } from '@/src/api/drawing'
import { DrawingDisplay } from '@/src/components/manage/views/DrawingDisplay'
import { SpinnerOverlay } from '@/src/components/SpinnerOverlay'

export const Route = createFileRoute('/drawing/$shareId')({
  component: DrawingSharePage,
})

function DrawingSharePage() {
  const { shareId } = Route.useParams()

  const { data: drawing, isLoading, error } = useQuery({
    queryKey: ['drawing', 'byShareId', shareId],
    queryFn: () => getDrawingByShareId({ data: { shareId } }),
  })

  if (isLoading) {
    return <SpinnerOverlay text="Loading drawing..." />
  }

  if (error) {
    return (
      <main className="container mx-auto px-4 sm:px-0">
        <h1 className="text-2xl font-bold mb-4 text-red-500">Error Loading Drawing</h1>
        <p className="text-muted-foreground mb-2">Share ID: {shareId}</p>
        <p className="text-red-500">
          {error instanceof Error ? error.message : 'Failed to load drawing'}
        </p>
      </main>
    )
  }

  if (!drawing) {
    throw notFound()
  }

  return <DrawingDisplay drawing={drawing} />
}
